import { routes } from 'commons/constants/routes'
import { ButtonGroup, Link } from 'ui/components'
import { Button } from 'ui/components/Buttons'

import { useDocumentsListContext } from '../context/DocumentsListContext'

export const Actions = () => {
  const {
    data: { canAddNew, canAccessDocumentTemplates }
  } = useDocumentsListContext()

  return (
    <ButtonGroup margin="small">
      {canAccessDocumentTemplates && (
        <Link to={routes.bank.documentTemplates.index}>
          <Button face="tertiary">Template Manager</Button>
        </Link>
      )}

      {canAddNew && (
        <Link to="/documents/new">
          <Button face="tertiary">Add New</Button>
        </Link>
      )}
    </ButtonGroup>
  )
}
